/**
 * Request header that tells the API which client and version made the call:
 * `<name>/<version>[+<build>]`, e.g. `partners/0.1.0+3f2a9c1`. The API turns it into the
 * `client.name` / `client.version` / `client.platform` log fields.
 */
export const CLIENT_HEADER_NAME = 'x-client';

/** Version sent when the build constant is unavailable (tests, a broken build). */
export const FALLBACK_CLIENT_VERSION = '0.0.0';

const SEMVER_PATTERN = /^\d+\.\d+\.\d+(?:-[0-9A-Za-z.-]+)?$/;
const BUILD_PATTERN = /^[0-9A-Za-z.-]+$/;
const GIT_SHA_PATTERN = /^[0-9a-f]{7,40}$/i;
const SHORT_SHA_LENGTH = 7;

/**
 * `<name>/<version>[+<build>]`. A version that is not semver falls back to `0.0.0`; a build with
 * characters semver does not allow is dropped.
 */
export const buildClientHeaderValue = ({
  name,
  version,
  build,
}: {
  name: string;
  version?: string | null;
  build?: string | null;
}): string => {
  const safeVersion = version && SEMVER_PATTERN.test(version) ? version : FALLBACK_CLIENT_VERSION;
  const safeBuild = build && BUILD_PATTERN.test(build) ? `+${build}` : '';
  return `${name}/${safeVersion}${safeBuild}`;
};

/**
 * Short git SHA of the release the deploy exports (`VITE_APP_RELEASE`, `git rev-parse HEAD`).
 * `null` for `local-dev` or anything that is not a SHA.
 */
export const toBuildSha = (release?: string | null): string | null =>
  release && GIT_SHA_PATTERN.test(release)
    ? release.slice(0, SHORT_SHA_LENGTH).toLowerCase()
    : null;
